import { GruserType } from '@wix/da-gruser-shared/pkg/types';
import { Gruser } from '@wix/da-gruser-shared/pkg/types/papi';
import { PapiUser } from '@wix/da-papi-types';
import { URLS, Url } from '@wix/da-url';
import { ExhibitionistWidgetType } from './types';
import { isGroup } from '../../User/helpers';

export const getExhibitionistWidgetType = ({
  gruser,
  zone: { name: zoneName },
}: {
  gruser: Gruser;
  zone: { name: string };
}): ExhibitionistWidgetType => {
  if (gruser.gruserTypeid === GruserType.Deviation) {
    return ExhibitionistWidgetType.STRIP_SHORT;
  } else {
    return zoneName === 'topBar'
      ? ExhibitionistWidgetType.STRIP
      : ExhibitionistWidgetType.TALL;
  }
};

export const getSubmitUrlForProfileOwner = (profileOwner: PapiUser): string => {
  return isGroup(profileOwner)
    ? Url.submissionLinkWithGroupId(profileOwner.userId)
    : Url.to(URLS.STUDIO);
};
